import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CacheConfig } from '../cache-config';
import { ExpiryStorage } from './expiry-storage';
var WebCacheStorage = /*#__PURE__*/function () {
  /**
   * Whether the Cache API is supported
   */

  /**
   * Expiry storage
   */

  /**
   * Initialise the WebCacheStorage
   * @param cacheName The name of the cache to use. See {@link https://developer.mozilla.org/en-US/docs/Web/API/CacheStorage/open}
   * @param onError a callback when any error occurs
   */
  function WebCacheStorage(cacheProviderConfig) {
    _classCallCheck(this, WebCacheStorage);
    this.supported = (typeof caches === "undefined" ? "undefined" : _typeof(caches)) === 'object' && typeof caches.open === 'function';
    this.cacheConfig = new CacheConfig(cacheProviderConfig);
    this.expiryStorage = new ExpiryStorage(this.cacheConfig);
  }

  /**
   * Get cached response
   */
  _createClass(WebCacheStorage, [{
    key: "get",
    value: (function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
        var cache, expired;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.supported) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", undefined);
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return caches.open(this.cacheConfig.cacheName);
            case 5:
              cache = _context.sent;
              _context.next = 8;
              return this.isExpired(request);
            case 8:
              expired = _context.sent;
              if (!expired) {
                _context.next = 13;
                break;
              }
              _context.next = 12;
              return this.delete(request);
            case 12:
              return _context.abrupt("return", undefined);
            case 13:
              return _context.abrupt("return", cache.match(this.getCacheKey(request)));
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](2);
              this.cacheConfig.onError(_context.t0);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 16]]);
      }));
      function get(_x) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
    /**
     * Put response in cache
     */
    )
  }, {
    key: "set",
    value: (function () {
      var _set = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(request, response) {
        var cache, expiryDate;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.supported) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return caches.open(this.cacheConfig.cacheName);
            case 5:
              cache = _context2.sent;
              expiryDate = Date.now() + this.cacheConfig.ttl * 1000;
              _context2.next = 9;
              return this.expiryStorage.setExpiry(this.getStoreKey(request), expiryDate);
            case 9:
              _context2.next = 11;
              return cache.put(this.getCacheKey(request), response);
            case 11:
              _context2.next = 16;
              break;
            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](2);
              this.cacheConfig.onError(_context2.t0);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 13]]);
      }));
      function set(_x2, _x3) {
        return _set.apply(this, arguments);
      }
      return set;
    }()
    /**
     * Delete cached response
     */
    )
  }, {
    key: "delete",
    value: (function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(request) {
        var _this = this;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (this.supported) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return", true);
            case 2:
              _context4.prev = 2;
              return _context4.abrupt("return", caches.open(this.cacheConfig.cacheName).then( /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(cache) {
                  return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        _context3.next = 2;
                        return cache.delete(_this.getCacheKey(request));
                      case 2:
                        _context3.next = 4;
                        return _this.expiryStorage.deleteExpiry(_this.getStoreKey(request));
                      case 4:
                        return _context3.abrupt("return", true);
                      case 5:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee3);
                }));
                return function (_x5) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 6:
              _context4.prev = 6;
              _context4.t0 = _context4["catch"](2);
              this.cacheConfig.onError(_context4.t0);
              return _context4.abrupt("return", false);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[2, 6]]);
      }));
      function _delete(_x4) {
        return _delete2.apply(this, arguments);
      }
      return _delete;
    }()
    /**
     * Check if the cached response is expired
     */
    )
  }, {
    key: "isExpired",
    value: (function () {
      var _isExpired = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(request) {
        var key, expiry;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              key = this.getStoreKey(request);
              _context5.next = 4;
              return this.expiryStorage.getExpiry(key);
            case 4:
              expiry = _context5.sent;
              return _context5.abrupt("return", Date.now() > (expiry !== null && expiry !== void 0 ? expiry : 0));
            case 8:
              _context5.prev = 8;
              _context5.t0 = _context5["catch"](0);
              this.cacheConfig.onError(_context5.t0 instanceof Error ? _context5.t0 : new Error('Error checking expiry'));
              return _context5.abrupt("return", true);
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 8]]);
      }));
      function isExpired(_x6) {
        return _isExpired.apply(this, arguments);
      }
      return isExpired;
    }()
    /**
     * Compose the URL and the use case as the search params to cache the response
     */
    )
  }, {
    key: "getCacheKey",
    value: function getCacheKey(request) {
      var url = new URL(request.url);
      url.searchParams.set('useCase', this.cacheConfig.useCase);
      return url;
    }

    /**
     * Get the key to store the response
     * Interally, it hashes the request body to get a unique key
     */
  }, {
    key: "getStoreKey",
    value: function getStoreKey(request) {
      return this.getCacheKey(request).toString();
    }
  }]);
  return WebCacheStorage;
}();
export { WebCacheStorage as default };